<ifc-base-dialog title="Funding transfer started" [actions]="actions" (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <p class="secondary-text">
      <span>
        Your funding transfer in the amount of {{ data.disbursedAmount | currency: 'USD' : 'symbol' : '1.2-2' }} has
        started.
      </span>
      <span *ngIf="data.bankIntegrationRequired">Link your bank to speed up the funding process.</span>
      <span>Transfers take 1-2 business days to be processed.</span>
    </p>
    <div>
      <ifc-simple-horizontal-list-widget
        title="New account balances"
        [listItems]="listItems"
        [config]="listWidgetConfig"
      ></ifc-simple-horizontal-list-widget>
    </div>
  </ng-template>
</ifc-base-dialog>
